module.exports = __webpack_public_path__ + "img/IQ.30b15f82.svg";